import { useReadDocuments } from '@/api/accounting-dealer'
import { DocumentInput } from '@/components/document-input'
import { Skeleton } from '@mui/material'
import { useOutletContext } from 'react-router-dom'
import { ReadDealResponse } from '@/types'

type CompanyDocumentsProps = {
  entity_key: string
}

export const CompanyDocuments = ({ entity_key }: CompanyDocumentsProps) => {
  const { deal } = useOutletContext<ReadDealResponse>()

  const { data: documents, isLoading: isLoadingDocuments } = useReadDocuments({
    entity_key,
    entity_type: 'company',
  })

  const isChangeAccountant = deal.company.status === 'changing_accountant'

  if (isLoadingDocuments) {
    return <Skeleton variant="rectangular" height={100} />
  }

  return (
    <>
      {isChangeAccountant ? (
        <DocumentInput
          fieldName="company.company_social_contract"
          entity={{ key: entity_key, type: 'company' }}
          documents={documents || []}
          documentType="company_social_contract"
          required={isChangeAccountant}
        />
      ) : (
        <DocumentInput
          fieldName="company.iptu"
          entity={{ key: entity_key, type: 'company' }}
          documents={documents || []}
          documentType="iptu"
          required={!isChangeAccountant}
        />
      )}
    </>
  )
}
